import React from 'react';
import { SIDEBAR_FULL_WIDTH } from '../Sidebar';
import { ListItemButton, ListItemIcon, ListItemText, Paper, Popper } from '@mui/material';
import { boxShadows, colours } from '../../../StyleConstants';

type SidebarItemProps = {
  id: string;
  selected: boolean;
  label: string;
  icon: any;
  onClick: any;
  hoverTooltip?: string;
}

const SidebarItem = (props: SidebarItemProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleHover = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <div onMouseEnter={handleHover} onMouseLeave={() => setAnchorEl(null)}>
            {
                props.hoverTooltip &&
      <Popper id={id} open={open} anchorEl={anchorEl} placement={"right-end"}>
          <Paper sx={{ padding: 3, boxShadow: boxShadows.levelFive, marginLeft: 1 }}>
              {props.hoverTooltip}
          </Paper>
      </Popper>
            }
            <li aria-describedby={id}>
                <ListItemButton
                    id={props.id}
                    key={props.label}
                    disableRipple
                    sx={props.selected
                        ? {
                            height: "50px",
                            backgroundColor: "#F9FAFC",
                            width: SIDEBAR_FULL_WIDTH + 8,
                            borderRadius: "8px 0px 0px 8px",
                            "&:hover": {
                                backgroundColor: "#F9FAFC",
                            },
                            "&:focus": {
                                backgroundColor: "#F9FAFC",
                            },
                        }
                        : {
                            height: "50px",
                            width: SIDEBAR_FULL_WIDTH + 8,
                        }}
                    onClick={props.onClick}
                >
                    <ListItemIcon>
                        <props.icon
                            sx={props.selected
                                ? {
                                    color: colours.orange.orange,
                                    width: "1rem",
                                    aspectRatio: 1,
                                }
                                : {
                                    color: "white",
                                    width: "1rem",
                                    aspectRatio: 1,
                                }}
                        />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={props.label}
                        sx={props.selected
                            ? {
                                color: colours.orange.orange,
                                marginLeft: "-1rem",
                                fontWeight: "600",
                            }
                            : { marginLeft: "-1rem" }}
                    />
                </ListItemButton>
            </li>
        </div>

    )
}


export default SidebarItem;